/* FiftyOne Designs — Scroll Reveal
   Adds .is-visible to any .fo-reveal element as it enters the viewport.
   Loaded async from theme.liquid — no dependencies. */
(function () {
  'use strict';

  /* Respect user motion preference — reveal everything immediately */
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.fo-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  /* Fallback for browsers without IntersectionObserver */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.fo-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function observe() {
    document.querySelectorAll('.fo-reveal:not(.is-visible)').forEach(function (el) {
      io.observe(el);
    });
  }
  observe();
  /* Re-run after dynamic section renders (Shopify theme editor) */
  document.addEventListener('shopify:section:load', observe);
})();
